import { useState } from "react";
import Sidebar from "@/components/Sidebar";
import OutsourcedSyncTab from "./OutsourcedSyncTab";
import OutsourcedReportTab from "./OutsourcedReportTab";
import OutsourcedFilesTab from "./OutsourcedFilesTab";

export default function OutsourcedPage() {
  const [tab, setTab] = useState("sync");

  const tabClass = (name) =>
    `px-4 py-2 text-sm font-medium border-b-2 -mb-px ${
      tab === name ? "border-[#5990DC] text-[#5990DC]" : "border-transparent text-gray-500 hover:text-gray-700"
    }`;

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <main className="flex-1 overflow-auto p-6">
        <div className="flex gap-2 mb-6 border-b border-gray-200">
          <button onClick={() => setTab("sync")} className={tabClass("sync")}>Sync Data</button>
          <button onClick={() => setTab("report")} className={tabClass("report")}>Report</button>
          <button onClick={() => setTab("files")} className={tabClass("files")}>Files</button>
        </div>
        {tab === "sync" ? <OutsourcedSyncTab /> : tab === "report" ? <OutsourcedReportTab /> : <OutsourcedFilesTab />}
      </main>
    </div>
  );
}
